import { render, staticRenderFns } from "./play.vue?vue&type=template&id=ecc493ba&scoped=true&"
import script from "./play.vue?vue&type=script&lang=js&"
export * from "./play.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc493ba",
  null
  
)

export default component.exports